module.exports = __webpack_public_path__ + "img/check.60efbe64.png";